import { fetchToken, setAppLoading } from 'containers/Login/loginSlice'
import { ViewProvider } from 'context/ViewContext'
import DeviceProvider from 'context/Device'
import { getDeviceInfo } from 'utils/device'
import NotificationProvider from 'utils/NotificationProvider'
import ConnectionProvider from 'context/connection/Provider'
import SocketProvider from 'context/socket/SocketProvider'
import Notifications from 'containers/Notifications'
import { exportLogsInIos } from 'utils/nativeApp'
import AppProvider from 'context/AppProvider'
import StoreManager from 'rest/storeManager'
import { Provider } from 'react-redux'
import { getConfig } from 'appSlice'
import * as process from 'process'
import { pdfjs } from 'react-pdf'
import ReactDOM from 'react-dom'
import View from 'layouts/View'
import Router from './Router'
import store from './store'
import React from 'react'
import Auth from './Auth'
import App from './App'
import './index.css'

/**
 * Fix for simple-peer package
 */
window.global = window;
window.process = process;

/**
 * Saving a store instance to a singleton
 */
StoreManager.set(store)
store.dispatch(getConfig())
if (!window.location.pathname.includes('oauth')) {
  store.dispatch(fetchToken())
} else {
  store.dispatch(setAppLoading(false))
}

/**
 * Logs for native ios app
 */
exportLogsInIos()

/**
 * Setting PDF viewer
 */
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

const app = <React.StrictMode>
  <Provider store={store}>
    <DeviceProvider deviceInfo={getDeviceInfo()}>
      <ViewProvider>
        <ConnectionProvider>
          <SocketProvider>
            <App>
              <Router>
                <Auth>
                  <NotificationProvider>
                    <AppProvider>
                      <View />
                      <Notifications />
                    </AppProvider>
                  </NotificationProvider>
                </Auth>
              </Router>
            </App>
          </SocketProvider>
        </ConnectionProvider>
      </ViewProvider>
    </DeviceProvider>
  </Provider>
</React.StrictMode>

ReactDOM.render(app, document.getElementById('root'))
